<template>
    <div class="browser-simulator">
        <div class="browser-header">
            <button title="voltar na navegação"
                    @click="goBack"
                    :disabled="siglasHistory.length === 0 || (siglasHistory.length <= 1 && props.type === 'faq')"
                    style="border-radius: 50%; display: flex; justify-content: center; align-items: center; padding: 8px;"
            >
                <ArrowLeftOutlined/>
            </button>
            <a-breadcrumb style="width: 80vw; margin-left: 10px">
                <a-breadcrumb-item>
                    <span>{{ mapperType[props.type] }}</span>
                </a-breadcrumb-item>
                <a-breadcrumb-item v-for="item of siglasHistory">
                    {{ item.name }}
                </a-breadcrumb-item>
            </a-breadcrumb>

            <button @click="printPage" class="printBtn">
                <PrinterOutlined /> Imprimir
            </button>
        </div>
        <ViewHtmlUsosSolo :zona-id="props.zonaId" v-if="props.type === 'usos-solo' && showComponentePrincipal"
                          @to-sigla="to"></ViewHtmlUsosSolo>
        <ViewHtmlOcupacoesSolo :zona-id="props.zonaId" v-if="props.type === 'ocupacoes-solo' && showComponentePrincipal"
                               @to-sigla="to"></ViewHtmlOcupacoesSolo>

        <ViewHtmlSiglas v-if="showComponenteSigla" :id="idSigla" @to-sigla="to"></ViewHtmlSiglas>

        <ViewHtmlFAQs :id="idFaq" v-if="props.type === 'faq' && showComponentePrincipal" @getFaq="to"></ViewHtmlFAQs>
    </div>
</template>

<script setup>
import {computed, onMounted, ref} from "vue";
import ViewHtmlUsosSolo from "../Viabilidade/UsosSolo/ViewHtmlUsosSolo.vue";
import ViewHtmlSiglas from "../Viabilidade/Siglas/ViewHtmlSiglas.vue";
import ViewHtmlOcupacoesSolo from "../Viabilidade/OcupacoesSolo/ViewHtmlOcupacoesSolo.vue";
import ViewHtmlFAQs from "../Configurations/Faqs/ViewHtmlFAQs.vue";
import {ArrowLeftOutlined, PrinterOutlined} from "@ant-design/icons-vue";

const siglasHistory = ref([])
const currentType = computed(() => props.type)
const mapperType = ref({
    "usos-solo": "Usos do Solo:",
    "ocupacoes-solo": "Ocupações do Solo:",
    "faq": "Tutoriais"
})

const printPage = () => window.print()

const props = defineProps(['id', 'zonaId', 'type'])

const idSigla = ref(null)
const idFaq = ref(props.id)
const showComponentePrincipal = ref(!idSigla.value)
const showComponenteSigla = ref(false)

const to = async (sigla) => {
    idSigla.value = parseInt(sigla.id);
    siglasHistory.value.push(sigla);
    const hasHistory = siglasHistory.value.length > 1;

    if (!idSigla.value) return;

    if (props.type === 'faq') {
        idFaq.value = sigla.id;
        showComponenteSigla.value = false;
        showComponentePrincipal.value = false;
        await (new Promise(resolve => setTimeout(resolve, 1)));
        showComponentePrincipal.value = true;
    } else {
        showComponentePrincipal.value = false;
        showComponenteSigla.value = !hasHistory;
        if (hasHistory) {
            await (new Promise(resolve => setTimeout(resolve, 1)));
            showComponenteSigla.value = true;
        }
    }
}

const goBack = async () => {
    if (siglasHistory.value.length === 1) {
        siglasHistory.value = []
        showComponenteSigla.value = false
        showComponentePrincipal.value = true
    }

    if (siglasHistory.value.length > 1) {
        if (props.type === 'faq') {
            siglasHistory.value.pop()
            showComponentePrincipal.value = false
            idFaq.value = (siglasHistory.value.at(-1)).id
            await (new Promise(resolve => setTimeout(resolve, 1)));
            showComponentePrincipal.value = true
        } else {
            siglasHistory.value = siglasHistory.value.filter(sigla => sigla.id !== idSigla.value);
            showComponenteSigla.value = false
            idSigla.value = (siglasHistory.value.at(-1)).id
            await (new Promise(resolve => setTimeout(resolve, 1)));
            showComponenteSigla.value = true
        }
    }
};

onMounted(async () => {
    let id = currentType.value === 'faq' ? props.id : props.zonaId
    let type = currentType.value === 'faq' ? 'faqs' : currentType.value
    let route = ''
    if (currentType.value === 'faq') {
        route = `/api/configurations/${type}/${id}`;
        siglasHistory.value.push((await window.axios.get(route)).data.data);
    }
})
</script>

<style scoped>
.browser-simulator {
    width: 100%;
    border: 1px solid #ccc;
    border-radius: 8px;
    overflow: hidden;
    font-family: Arial, sans-serif;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.browser-header {
    display: flex;
    align-items: center;
    padding: 8px;
    background-color: #f9f9f9;
    border-bottom: 1px solid #ddd;
}

.browser-header input {
    flex: 1;
    padding: 4px 8px;
    margin: 0 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

.browser-header button {
    padding: 4px 8px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

.browser-header button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
}

.browser-body iframe {
    width: 100%;
    height: 400px;
    border: none;
}

.printBtn {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
}

@media print {
    .printBtn {
        visibility: hidden;
    }

    .browser-simulator {
        border: none;
        box-shadow: none;
    }
}
</style>
